import { IFilter } from '../../interfaces/filter.interface';

export class DateFilter implements IFilter<Date | undefined> {
  private _filterValue: Date | undefined;

  public update(value: Date | undefined): void {
    this._filterValue = value;
  }
  public getFilterValue(): Date | undefined {
    return this._filterValue;
  }
}
